import { ChangeDetectionStrategy, Component } from '@angular/core';

// Presentational spinner. Add the `small` attribute (`<cs-spinner small>`) for a
// slightly smaller variant — styled purely via the host attribute in cs-spinner.scss.
@Component({
    selector: 'cs-spinner',
    templateUrl: 'cs-spinner.html',
    host: { 'class': 'spinner' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsSpinnerComponent { }
